import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { dateFormat } from 'enums';
import { list } from 'styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var OfficeDetails = function OfficeDetails(_ref) {
  var _office$name, _office$city, _office$address, _office$franchisee$na, _office$franchisee, _office$partners$map$, _office$partners;

  var office = _ref.office;
  return ___EmotionJSX("div", {
    css: list
  }, ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0418\u043C\u0435"), ___EmotionJSX("p", {
    className: "value"
  }, (_office$name = office === null || office === void 0 ? void 0 : office.name) !== null && _office$name !== void 0 ? _office$name : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0413\u0440\u0430\u0434"), ___EmotionJSX("p", {
    className: "value"
  }, (_office$city = office === null || office === void 0 ? void 0 : office.city) !== null && _office$city !== void 0 ? _office$city : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0410\u0434\u0440\u0435\u0441"), ___EmotionJSX("p", {
    className: "value"
  }, (_office$address = office === null || office === void 0 ? void 0 : office.address) !== null && _office$address !== void 0 ? _office$address : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041A\u0440\u0435\u0434\u0438\u0442\u0435\u043D \u043F\u043E\u0441\u0440."), ___EmotionJSX("p", {
    className: "value"
  }, (_office$franchisee$na = office === null || office === void 0 ? void 0 : (_office$franchisee = office.franchisee) === null || _office$franchisee === void 0 ? void 0 : _office$franchisee.name) !== null && _office$franchisee$na !== void 0 ? _office$franchisee$na : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0420\u0430\u0431\u043E\u0442\u0438 \u0441 \u043F\u0430\u0440\u0442\u043D\u044C\u043E\u0440\u0438"), ___EmotionJSX("p", {
    className: "value"
  }, (_office$partners$map$ = office === null || office === void 0 ? void 0 : (_office$partners = office.partners) === null || _office$partners === void 0 ? void 0 : _office$partners.map(function (el) {
    return el === null || el === void 0 ? void 0 : el.name;
  }).join(', ')) !== null && _office$partners$map$ !== void 0 ? _office$partners$map$ : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0421\u044A\u0437\u0434\u0430\u0434\u0435\u043D \u043D\u0430"), ___EmotionJSX("p", {
    className: "value"
  }, moment(office === null || office === void 0 ? void 0 : office.created_at).isValid() ? moment(office === null || office === void 0 ? void 0 : office.created_at).format(dateFormat) : 'N/A')));
};

OfficeDetails.propTypes = {
  office: PropTypes.object
};
export default OfficeDetails;